module.exports = "<div class=\"alert alert-danger alert-absolute\"> <a href=# class=close aria-label=close title=close>×</a> <strong>This visualization requires WebGL support.</strong><br> Please check that you are using a supported browser, and that WebGL is <a href=https://get.webgl.org/ >enabled</a>. </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/supportWarning/webGlWarning.html
// module id = 32
// module chunks = 0